// Getters
export const events = (state) => {
  return state.events.data || []
}
export const eventsLoading = (state) => {
  return state.events.loading
}
export const eventsLastUpdate = (state) => {
  return state.events.lastUpdate
}

export const prospects = (state) => {
  return state.prospects.data || []
}
export const prospectsLoading = (state) => {
  return state.prospects.loading
}
export const prospectsLastUpdate = (state) => {
  return state.prospects.lastUpdate
}

